var map = {
	"./callonetta.jpg": "4286",
	"./cominfo.jpg": "8bbf",
	"./czytelnia.jpg": "c87b",
	"./fotobartodzieje.jpg": "3e29",
	"./intre.jpg": "db94",
	"./notariuszio.jpg": "1513",
	"./pizza.jpg": "d78a",
	"./sopur.jpg": "8dbb",
	"./vcx.jpg": "93ca"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cc1f";